import referralCouponReducer from './reducer';

export default referralCouponReducer;

export {
  FETCH_REFERRAL_COUPON_REQUEST,
  FETCH_REFERRAL_COUPON_SUCCESS,
  FETCH_REFERRAL_COUPON_FAILURE,
  fetchReferralCouponRequest,
  fetchReferralCouponSuccess,
  fetchReferralCouponFailure
} from './actions';

export { getReferralCoupon } from './selectors';



// WEBPACK FOOTER //
// ./src/store/referralCoupon/index.js